<qvs-login-page-header></qvs-login-page-header>
<form class="qvs-registration-form" [formGroup]="registrationForm" (ngSubmit)="submit($event)">
  <p class="qvs-registration-form__label">{{ 'ebanking.login.LABEL' | translate }}</p>
  <ion-item class="qvs-registration-form__input-item" lines="none">
    <ion-input
      class="qvs-registration-form__input"
      formControlName="contractnumber"
      type="text"
      placeholder="{{ 'ebanking.registration.INPUT_PLACEHOLDER' | translate }}"
    ></ion-input>
  </ion-item>

  <ion-item class="qvs-registration-form__input-item" lines="none">
    <ion-input
      class="qvs-registration-form__input"
      formControlName="initialPassphrase"
      type="password"
      placeholder="{{ 'ebanking.registration.INPUT_INITIAL_PASSPHRASE' | translate }}"
    ></ion-input>
  </ion-item>

  <ion-button
    class="qvs-registration-form__button"
    expand="block"
    type="submit"
    [disabled]="isButtonDisabled() || (isLoading$ | async)"
    >{{ 'ebanking.registration.BUTTON' | translate }}
  </ion-button>

  <p class="qvs-registration-form__login-hint">
    <span>{{ 'ebanking.registration.GO_TO_LOGIN_TEXT' | translate }}</span>
    <button class="qvs-registration-form__login-hint__action" type="button" (click)="goToLogin()">
      {{ 'ebanking.registration.GO_TO_LOGIN_BUTTON' | translate }}
    </button>
  </p>

  <qvs-info-box
    *ngIf="isServerError$ | async"
    [text]="'ebanking.registration.INFO_BOX_TEXT' | translate"
    class="qvs-registration-form__error_box"
  ></qvs-info-box>
</form>
